function updateStripeCustomer({ customerId, metadata}){
    return fetch("/.netlify/functions/updateStripeCustomer", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ customerId, metadata })
    })
}

export default updateStripeCustomer;